var exports = {
  "GG": "OperatorPassShowcase.module__showcase___azZJWX",
  "dw": "OperatorPassShowcase.module__stage___azZJWX",
  "M6": "OperatorPassShowcase.module__slide___azZJWX",
  "li": "OperatorPassShowcase.module__picture___azZJWX",
  "Sl": "OperatorPassShowcase.module__image___azZJWX",
  "DD": "OperatorPassShowcase.module__title___azZJWX",
  "rf": "OperatorPassShowcase.module__body___azZJWX",
  "qr": "OperatorPassShowcase.module__footer___azZJWX",
  "r$": "OperatorPassShowcase.module__dots___azZJWX",
  "Om": "OperatorPassShowcase.module__dot___azZJWX",
  "a_": "OperatorPassShowcase.module__terms___azZJWX",
  "WE": "OperatorPassShowcase.module__termsLink___azZJWX",
  "oE": "OperatorPassShowcase.module__compact___azZJWX",
};

module.exports = exports;
